import React, { useCallback, useEffect, useState } from "react";
import { Comment } from "@/components";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { message, Modal } from "antd";
import { checkResult, createFilePath, second2DateTime } from "@/common";
import "./style.less";

function CommentModule(props) {
  const [[i18n]] = useWatchState(["i18n"]);
  const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
  const [[user]] = useWatchState(["user"]);

  const [content, setContent] = useState();
  const [comments, setComments] = useState([]);

  // 查询评论
  const getComments = (id, type) => {
    BaseService.list({
      table: "thtt_comment",
      columns: "comment_id,content,add_time AS addTime, like_amount,add_user",
      leftJoin: {
        table: "thtt_user",
        on: "thtt_comment.add_user = thtt_user.user_id",
        columns: ["nickname AS name", "avatar AS head"],
      },
      where: { "thtt_comment.item_id": id, "thtt_comment.item_type": type },
      order: ["thtt_comment.add_time DESC"],
    }).then((res) => {
      if (!checkResult(res)) return;
      setComments(
        res.data.result.map((vo) => ({
          ...vo,
          key: vo.comment_id,
          addTime: second2DateTime(vo.addTime),
          head: createFilePath(vo.head, UPLOAD_SERVER_HOST),
          remove: vo.add_user === user.info.user_id,
        }))
      );
    });
  };

  useEffect(() => {
    getComments(props.itemId, props.type);
  }, []);

  const onChangeHandler = useCallback((e) => {
    setContent(e.target.value);
  }, []);

  const onSubmitHandler = useCallback(
    (e) => {
      BaseService.add({
        table: "thtt_comment",
        key: "comment_id",
        data: {
          item_id: props.itemId,
          item_type: props.type,
          add_user: user.info.user_id,
          content,
          add_time: Math.floor(new Date() / 1000),
        },
      }).then((res) => {
        if (!checkResult(res)) return;
        setContent("");
        getComments(props.itemId, props.type);
      });
    },
    [content]
  );

  const onRemoveHandler = useCallback((key) => {
    Modal.confirm({
      title: "确认删除此留言吗?",
      content: "删除后无法恢复",
      onOk() {
        console.log("ok");
        BaseService.remove({
          table: "thtt_comment",
          where: {
            comment_id: key,
          },
        }).then((res) => {
          console.log(res);
          if (!checkResult(res)) return;
          message.success("删除成功！");
          getComments(props.itemId, props.type);
        });
      },
    });
  }, []);

  return (
    <div className={`module-comment ${props.className}`}>
      <div className="module-comment__inputContainer">
        <textarea
          className="module-comment__input"
          value={content}
          onChange={onChangeHandler}
        ></textarea>
        <button className="module-comment__submit" onClick={onSubmitHandler}>
          {i18n.submit}
        </button>
      </div>
      <Comment
        className={props.className}
        data={comments}
        onRemove={onRemoveHandler}
      />
    </div>
  );
}

export default CommentModule;
